import { Document } from "../../models"
export const distantFuture = new Date(8640000000000000)

export type SortOption = 'dueDateUTC' | 'docTimestamp' | 'title' | 'rating' | ''
export type SortOrder = 'desc' | 'asc'

type AdditionalData = {
    isEnabledRating: (dataType: string) => boolean
}

const startsWithNumber = (str: string): boolean => {
    return /^-?\d+\.?\d*/.test(str);
}

const reGetFitstNum = /[^-?\d+\.?\d].*/g;

const checkRemoveDots = (a: string) => {
    const parts = a.split(".")
    if(parts.length <= 2) return a
    return parts.join("")
}

const sortByCreation = (items: Document[], sortOrder: SortOrder): Document[] => {
    return items.sort((a, b) => {
        let dateA = a.docTimestamp ? new Date(a.docTimestamp) : distantFuture
        let dateB = b.docTimestamp ? new Date(b.docTimestamp) : distantFuture
        return sortOrder === 'asc' ? 
            dateA.getTime() - dateB.getTime() :
            dateB.getTime() - dateA.getTime()
    })
}

const sortByDueDate = (items: Document[], sortOrder: SortOrder): Document[] => {
    const itemsWithoutDueDate = items.filter(x => !x.dueDateUTC)
    const itemsWithDueDate = items.filter(x => !!x.dueDateUTC)

    const sortedByDueDate = itemsWithDueDate.sort((a, b) => {
        let dateA = a.dueDateUTC ? new Date(a.dueDateUTC) : distantFuture
        let dateB = b.dueDateUTC ? new Date(b.dueDateUTC) : distantFuture
        return sortOrder === 'asc' ? 
            dateA.getTime() - dateB.getTime() :
            dateB.getTime() - dateA.getTime()
    })

    const sortedByCreation = sortByCreation(itemsWithoutDueDate, 'asc')
    return [...sortedByDueDate, ...sortedByCreation]
}

const sortByTitle = (items: Document[], sortOrder: SortOrder): Document[] => {
    return items.sort((a, b) => {
        if(a.title === b.title) {
            let dateA = a.docTimestamp ? new Date(a.docTimestamp) : distantFuture
            let dateB = b.docTimestamp ? new Date(b.docTimestamp) : distantFuture
            return dateA.getTime() - dateB.getTime()
        }
        if(startsWithNumber(a.title) && startsWithNumber(b.title)) {
            const [aa, bb] = [a.title.replace(reGetFitstNum, ''), b.title.replace(reGetFitstNum, '')]
            const [aaRest, bbRest] = [a.title.match(reGetFitstNum)?.[0] || '', b.title.match(reGetFitstNum)?.[0] || '']
            const [correctAA, correctBB] = [checkRemoveDots(aa), checkRemoveDots(bb)]
            const [aaNum, bbNum] = [parseFloat(correctAA), parseFloat(correctBB)]
            if(aaNum === bbNum && !!aaRest && bbRest) {
                if(aaRest === bbRest) return 0
                return sortOrder === 'desc' ? 
                    a.title > b.title ? -1 : 1 : 
                    a.title > b.title ? 1 : -1
            }
            return sortOrder === 'desc' ? bbNum - aaNum : aaNum - bbNum
        }
        return sortOrder === 'desc' ? 
            a.title > b.title ? -1 : 1 : 
            a.title > b.title ? 1 : -1
      });
}

const sortByRating = (items: Document[], sortOrder: SortOrder, additionalData: AdditionalData): Document[] => {
    const itemsWithoutRating = items.filter(x => (!x.rating && x.rating !== 0) || !additionalData.isEnabledRating(x.dataType))
    const itemsWithRating = items.filter(x => (!!x.rating || x.rating === 0) && !!additionalData.isEnabledRating(x.dataType))
    
    const sortedByRating = itemsWithRating.sort((a, b) => {
        if(a.rating === b.rating) {
            let dateA = a.docTimestamp ? new Date(a.docTimestamp) : distantFuture
            let dateB = b.docTimestamp ? new Date(b.docTimestamp) : distantFuture
            return dateA.getTime() - dateB.getTime()
        }
        return sortOrder === 'desc' ? 
            a.rating > b.rating ? -1 : 1 : 
            a.rating > b.rating ? 1 : -1
    })

    const sortedByCreation = sortByCreation(itemsWithoutRating, 'asc')
    return [...sortedByRating, ...sortedByCreation]
}

export const sortKanbanLane = (items: Document[], sortOption: SortOption, sortOrder: SortOrder, additionalData: AdditionalData): Document[] => {
    switch (sortOption) {
        case 'docTimestamp':
            return sortByCreation(items, sortOrder)
        case 'dueDateUTC':
            return sortByDueDate(items, sortOrder)
        case 'title':
            return sortByTitle(items, sortOrder)
        case 'rating':
            return sortByRating(items, sortOrder, additionalData)
        default:
            return items
    }
}